import { render, staticRenderFns } from "./recommend-search.vue?vue&type=template&id=17234f57&scoped=true"
import script from "./recommend-search.vue?vue&type=script&lang=ts"
export * from "./recommend-search.vue?vue&type=script&lang=ts"
import style0 from "./recommend-search.vue?vue&type=style&index=0&id=17234f57&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17234f57",
  null
  
)

/* custom blocks */
import block0 from "./recommend-search.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports